export const CLEAR_ERRORS_CUSTOMERS_LOCATIONS = 'CLEAR_ERRORS_CUSTOMERS_LOCATIONS';
